export enum Units {
    UgPerM3 = 0,
    MgPerM3 = 1,
    Ppb = 2,
    Ppm = 3,
    Db = 4,
    UgPerCm2 = 5,
    UgPerFt2 = 6,
    FPerCc = 7,
    MgPerSample = 8,
    UgPerSample = 9,
    UgPerDl = 10,
    UmolPerL = 11,
    UgPerGCreatinine = 12,
    UgPerL = 13,
    UmolPerMol = 14,
    MPerS2 = 15,
    MPerS175 = 16
}

export enum UnitSymbols {
    'µg/m³' = Units.UgPerM3,
    'mg/m³' = Units.MgPerM3,
    'ppb' = Units.Ppb,
    'ppm' = Units.Ppm,
    'dB' = Units.Db,
    'µg/cm²' = Units.UgPerCm2,
    'µg/ft²' = Units.UgPerFt2,
    'f/cc' = Units.FPerCc,
    'mg/sample' = Units.MgPerSample,
    'µg/sample' = Units.UgPerSample,
    'µg/dL' = Units.UgPerDl,
    'µmol/L' = Units.UmolPerL,
    'µg/g creatinine' = Units.UgPerGCreatinine,
    'µg/L' = Units.UgPerL,
    'µmol/mol' = Units.UmolPerMol,
    'm/s²' = Units.MPerS2,
    'm/s^1.75' = Units.MPerS175
}
